import axios from 'axios'

export const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for auth
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('attendance_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // Normalize url: if url starts with /api/, strip /api prefix since backend routes are top-level
    if (config.url && config.url.startsWith('/api/')) {
      config.url = config.url.replace('/api/', '/')
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('attendance_token')
      localStorage.removeItem('attendance_user')
    }
    return Promise.reject(error)
  }
)

export default api
